import angular from 'angular';
import uiRouter from 'angular-ui-router';

import MenuComponent from './menu.component';

import Settings from './settings/settings';
import Discount from './discount/discount';
import Catalog from './catalog/catalog';
import Categories from './categories/categories'

import Main from './main/main';

const menuModule = angular.module('tinaba.components.menu', [
  uiRouter,
  Settings.name,
  Discount.name,
  Catalog.name,
  Categories.name,
  Main.name
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('menu', {
    url: '/menu',
    template: '<menu-page></menu-page>',
    redirect: 'menu.catalog',
    data: {
      services: true // show services in sidenav
    }
  });
})

.component('menuPage', MenuComponent); // can't call the component just "menu" because there it would overwrite an HTML tag already named like that

export default menuModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/menu.js
 **/